/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsBridgeSerialNumber
 */
export interface ControlcenterMelcoModelsBridgeSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsBridgeSerialNumber
     */
    new_email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsBridgeSerialNumber
     */
    serial_number?: string | null;
}

export function ControlcenterMelcoModelsBridgeSerialNumberFromJSON(json: any): ControlcenterMelcoModelsBridgeSerialNumber {
    return ControlcenterMelcoModelsBridgeSerialNumberFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsBridgeSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsBridgeSerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'new_email_address': !exists(json, 'new_email_address') ? undefined : json['new_email_address'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
    };
}

export function ControlcenterMelcoModelsBridgeSerialNumberToJSON(value?: ControlcenterMelcoModelsBridgeSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_email_address': value.new_email_address,
        'serial_number': value.serial_number,
    };
}


